import { Controller } from "@hotwired/stimulus"

// A responsive template carries both formats and therefore has no aspect ratio
// to pick (VOR-67). The field disappears while "responsive" is selected, and
// whatever stood in it goes with it — the model refuses a ratio on a responsive
// template, so leaving the value behind would only produce an error on save.
//
// The portrait preview image belongs to every template that is shown upright —
// a responsive and a portrait one (DAR-5) — so only a landscape one hides it.
export default class extends Controller {
  static targets = ["orientation", "aspectRatio", "aspectRatioField", "portraitPreviewImage"]

  connect() {
    this.toggle()
  }

  toggle() {
    const responsive = this.orientationTarget.value === "responsive"

    this.aspectRatioTarget.hidden = responsive
    this.portraitPreviewImageTarget.hidden = this.orientationTarget.value === "landscape"
    if (responsive) this.aspectRatioFieldTarget.value = ""
  }
}
